export default function Pagination({ hasMore, onMore, loading = false, shown = 0 }) {
  return (
    <div className="pagination">
      <span className="pagination-info">{shown} registro{shown === 1 ? '' : 's'}</span>
      {hasMore ? (
        <button type="button" className="btn btn-secondary" onClick={onMore} disabled={loading}>
          {loading ? 'Cargando…' : 'Cargar más'}
        </button>
      ) : null}
    </div>
  );
}
